export default "__VITE_ASSET__CwNbNxFk__"